import styled from "@emotion/styled";

import { DateField } from "react-aria-components";

export const StyledDateField = styled(DateField)``;
